<style scoped>
footer {
  text-align: center;
  color: darkgray;
}
</style>

<template>
  <b-container>
    <b-row>
      <b-col cols="12">
        <footer>
          <small>© 2020 Solis Engineering</small>
          <small> - client version: {{ version }} </small>
        </footer>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
    };
  },
};
</script>
